module.exports = __webpack_public_path__ + "media/images/new-ui-images/icon-2-d258f87eeac32f7129e1629c32a89d4d.svg";